module.exports = __webpack_public_path__ + "static/media/circle-info.19885e7e.svg";